import PurchaseType from '@/enums/PurchaseType';
import PurchaseTypeGroup from '@/enums/PurchaseTypeGroup';
import FundingType from '@/enums/FundingType';
import IFinance from '../interfaces/IFinance';

export default class Finance implements IFinance {
    public financeTerm: number = 0;

    public annualMileage: number = 0;

    public depositAmount: number = 0;

    public maintenanceRequired: boolean = false;

    public adverseCredit: boolean = false;

    public existingFleetSize: number = 0;

    public existingFleetSizeVans: number = 0;

    public businessName: string = '';

    public businessType: number = 0;

    public businessTimeEstablished: number = 0;

    public considerStock: boolean = false;

    public monthlyBudget: number = 0;

    public purchaseTypes: PurchaseType[] = [];

    public purchaseTypeGroup: PurchaseTypeGroup = PurchaseTypeGroup.NotSet;

    public fundingType: FundingType = FundingType.NotSet;

    public depositMonths: number = 0;
}
